import { render, staticRenderFns } from "./CamionBoiteRapMenu.vue?vue&type=template&id=393064b8&scoped=true&"
import script from "./CamionBoiteRapMenu.vue?vue&type=script&lang=js&"
export * from "./CamionBoiteRapMenu.vue?vue&type=script&lang=js&"
import style0 from "./CamionBoiteRapMenu.vue?vue&type=style&index=0&id=393064b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393064b8",
  null
  
)

export default component.exports